import { IIconProps } from 'main/common/components/icons/inner/IIconProps'
import React from 'react'
import { IconICP } from 'main/common/components/icons/inner/IconICP'

export function DeleteIconCP(props: IIconProps): JSX.Element {
    return <IconICP iconName={'delete'} {...props}/>
}
